import React from 'react';
import { connect } from "react-redux";
import TranslationService from "../app/services/TranslationService";


export class SplashScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        };
    }

    getClassName() {
        return 'splash-screen' + (this.props.splashScreen ? '' : ' inactive');
    }

    render() {
        let alphabet = TranslationService.trans(this.props.language, '_alphabet');
        if (alphabet === '_alphabet') {
            alphabet = 'latin';
        }

        return (
            <div className={this.getClassName()}>
                <div className="logo">
                    <svg
                        style={{width: '200px', animation: 'pulse-ring 1.5s cubic-bezier(0.215, 0.61, 0.355, 1) infinite'}}
                        viewBox="0 0 582 582"
                        id="Andra1"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            id="path1"
                            style={{fill: '#ff6400'}}
                            d="M 504.89844 133.76172 L 47.205078 255.61719 L 383.55469 591.95703 L 504.89844 133.76172 z M 416.03711 222.41797 L 350.43164 469.64062 L 169.88086 288.29102 L 416.03711 222.41797 z "
                            transform="scale(0.93741624)" />
                    </svg>

                    <svg
                        style={{width: '200px', animation: 'pulse-ring2 1.5s cubic-bezier(0.215, 0.61, 0.355, 1) infinite', position: 'relative', top: '-200px'}}
                        viewBox="0 0 582 582"
                        id="Andra2"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            id="path2"
                            style={{fill: '#ff6400'}}
                            d="M 504.89844 133.76172 L 47.205078 255.61719 L 383.55469 591.95703 L 504.89844 133.76172 z M 416.03711 222.41797 L 350.43164 469.64062 L 169.88086 288.29102 L 416.03711 222.41797 z "
                            transform="scale(0.93741624)" />
                    </svg>
                </div>

                <div className="madeby-mateusz-kolasa">
                    made by
                    <img src={"images/logo-mateuszkolasa-" + alphabet + ".svg"} alt="Mateusz Kolasa"/>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        splashScreen: state.splashScreen
    }
};
const mapDispatchToProps = {};

export const SplashScreenContainer = connect(mapStateToProps, mapDispatchToProps)(SplashScreen);
